import { forwardRef, useCallback } from 'react';

import { useForwardRef } from '@trello/dom-hooks';
import { useSharedStateSelector } from '@trello/shared-state';
import type { ListTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { cardDragAndDropState } from './cardDragAndDropState';

import styles from './ListCardDropPreview.less';

export const ListCardDropPreview = forwardRef<HTMLDivElement>((_, ref) => {
  const forwardedRef = useForwardRef(ref);
  const previewHeight = useSharedStateSelector(
    cardDragAndDropState,
    useCallback((state) => state.previewHeight, []),
  );

  return (
    <div
      ref={forwardedRef}
      className={styles.dropPreview}
      style={{ height: previewHeight }}
      data-testid={getTestId<ListTestIds>('list-card-drop-preview')}
    />
  );
});
